










































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'

@Component
export default class FinanceiroTabelaRegrasProdutividade extends Vue {
  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get regrasDeCalculo() { return this.getRegrasDeCalculoStore.regrasDeCalculo }

  loadRegrasDeCalculo: boolean = false
  get loadingRegrasDeCalculo() { return this.loadRegrasDeCalculo }
  set loadingRegrasDeCalculo(value: boolean) { this.loadRegrasDeCalculo = value }

  get paginacaoRegrasDeCalculo() { return this.getRegrasDeCalculoStore.paginacaoRegrasDeCalculo }

  get listStatus() {
    return [
      {
        key: true,
        text: 'Ativada',
      },
      {
        key: false,
        text: 'Desativada',
      },
    ]
  }

  get nomeRegra() {
    return this.getRegrasDeCalculoStore.nomeRegra
  }

  set nomeRegra(value: string) {
    this.getRegrasDeCalculoStore.setNomeRegra(value)
  }

  get statusRegra() {
    return this.getRegrasDeCalculoStore.ativo
  }

  set statusRegra(value: boolean | null) {
    this.getRegrasDeCalculoStore.setAtivo(value)
  }

  get filtrarPorEquipeProfissional() {
    return this.getRegrasDeCalculoStore.filtraPorEquipeProfissional
  }

  set filtrarPorEquipeProfissional(value: boolean | null) {
    this.getRegrasDeCalculoStore.setFiltrarPorEquipeProfissional(value)
  }

  regrasDeCalculoHeaders = [
    { text: 'Nome', value: 'descricaoRegra', sortable: false },
    { text: 'Valor de referência', value: 'valorDeReferencia', sortable: false },
    { text: 'Criado por', value: 'createdByNome', sortable: false },
    { text: 'Criado em', value: 'createdOn', sortable: false },
    { text: 'Status', value: 'ativo', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  loadingEditarRegraDeCalculo = ''

  displayDateAndHours(value: any) {
    if (!value) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  async editarRegraDeCalculo(item: any) {
    this.loadingEditarRegraDeCalculo = item.id
    const request = await this.getRegrasDeCalculoStore.getRegraCalculoById(item.id)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingEditarRegraDeCalculo = ''
      return
    }
    this.getRegrasDeCalculoStore.setMode('EDIT')
    this.getRegrasDeCalculoStore.setRegraDeCalculoId(item.id)
    await this.getRegrasDeCalculoStore.getLocalExecucaoByRegraCalculoId(this.getRegrasDeCalculoStore.paginacaoLocalExecucao)
    await this.getRegrasDeCalculoStore.getRegraCalculoContratoAll(this.getRegrasDeCalculoStore.paginacaoContratos)
    await this.getRegrasDeCalculoStore.getRegraCalculoOperadoraAll(this.getRegrasDeCalculoStore.paginacaoOperadoras)
    await this.getRegrasDeCalculoStore.getPlanoAll(this.getRegrasDeCalculoStore.paginacaoPlanos)
    await this.getRegrasDeCalculoStore.getPlanosAbrangencia()
    await this.getRegrasDeCalculoStore.getSetorAtendimentoByRegraCalculoId()
    await this.getRegrasDeCalculoStore.getFiltroPorProcedimentoList(this.getRegrasDeCalculoStore.paginacaoFiltroPorProcedimento)
    await this.getRegrasDeCalculoStore.getProcedimentosAll(this.getRegrasDeCalculoStore.paginacaoProcedimentos)
    await this.getRegrasDeCalculoStore.getProcedimentoCompartilhadoAll(this.getRegrasDeCalculoStore.paginacaoProcedimentos)
    await this.getRegrasDeCalculoStore.getRegraCalculoProcedimentoDescartarAll(this.getRegrasDeCalculoStore.paginacaoProcedimentosDescartar)
    await this.getRegrasDeCalculoStore.getEquipesProfissionalAll(this.getRegrasDeCalculoStore.paginacaoProcedimentosDescartar)
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculo', value: true })
    this.loadingEditarRegraDeCalculo = ''
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegraCalculoAll(param), 700)

  async updatePaginationRegrasDeCalculo(pagination: DataTablePagination) {
    this.loadingRegrasDeCalculo = true
    this.regrasDeCalculoDebounced(pagination)
    this.loadingRegrasDeCalculo = false
  }

  buscarRegrasDeCalculoFiltradas(filter: string) {
    this.loadingRegrasDeCalculo = true
    this.getRegrasDeCalculoStore.setPaginacaoRegrasDeCalculo({ ...this.paginacaoRegrasDeCalculo, page: 1 })
    this.regrasDeCalculoDebounced(filter)
    this.loadingRegrasDeCalculo = false
  }

  beforeDestroy() {
    this.getRegrasDeCalculoStore.clearRegrasDeCalculo()
    this.getRegrasDeCalculoStore.clearRegraDeCalculo()
    this.getRegrasDeCalculoStore.clearTabelasPreco()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoContratos()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoOperadoras()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoProcedimentosDescartar()
    this.getRegrasDeCalculoStore.clearFilterProdutividade()
  }
}
